<div class="main-container">
    <div class="header">
        Exercise Plans Uploader
    </div>
    <div>
        <mat-tab-group mat-align-tabs="start" >
            <mat-tab label="Create">
                <app-exercise-plans-uploader-create [exerciseCategories]="exerciseCategories" ></app-exercise-plans-uploader-create>
            </mat-tab>
            <mat-tab label="Edit">
                <app-exercise-plans-uploader-edit [exerciseCategories]="exerciseCategories" ></app-exercise-plans-uploader-edit>
            </mat-tab>
            <mat-tab label="Categories">
                <app-exercise-plans-uploader-categories [exerciseCategories]="exerciseCategories" ></app-exercise-plans-uploader-categories>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>